module.exports = __webpack_public_path__ + "static/img/header_footer_onboarding.e3110301.svg";